import { render, staticRenderFns } from "./MultiDisplayCategoriesSelector.vue?vue&type=template&id=e5abb35a&"
import script from "./MultiDisplayCategoriesSelector.vue?vue&type=script&lang=ts&"
export * from "./MultiDisplayCategoriesSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports